// extracted by mini-css-extract-plugin
export var cardHeader = "_h0-0";
export var reorderHandle = "_h0-3";
export var titleArea = "_h0-1";
export var titleAreaWithHandle = "_h0-2";